import { render, staticRenderFns } from "./dialog-managestorageonebox.vue?vue&type=template&id=3484e366&"
import script from "./dialog-managestorageonebox.vue?vue&type=script&lang=js&"
export * from "./dialog-managestorageonebox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports